module.exports = __webpack_public_path__ + "static/media/mobileMap_arrow.b5515942.png";